export { default as useLifestyleGammas } from './useLifestyleGammas';
